import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor"

//selectors
import { useCampusVirtualDataSegmentos } from "store/selectors"

const PieSegmentos = ({ dataColors }) => {
  //
  const apexSalesAnalyticsChartColors = getChartColorsArray(dataColors)
  const options = {
    labels: ["Series A", "Series B", "Series C"],
    colors: apexSalesAnalyticsChartColors,
    legend: { show: !1 },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
        },
      },
    },
  }

  const [series, setSeries] = useState([0, 0, 0])
  const [totales, setTotales] = useState([0, 0, 0])

  const dataSegmentos = useCampusVirtualDataSegmentos()

  useEffect(() => {
    if (dataSegmentos) {
      //
      if (!Array.isArray(dataSegmentos)) {
        console.error("Error: La variable 'dataSegmentos' no es un array.")
        return []
      }

      // Definir el orden de los segmentos
      const segmentos = ["Ocasionalmente Atrasado", "Puntual", "Moroso Crónico"]

      // Inicializar los arreglos con ceros
      let totales = [0, 0, 0]
      let series = [0, 0, 0]

      // Recorrer los datos de la API y asignar valores a los arreglos
      dataSegmentos.forEach(dato => {
        //console.log(dato)
        let index = segmentos.indexOf(dato.Segmento)
        if (index !== -1) {
          totales[index] = dato.TotalAlumnos
          series[index] = dato.PorcentajeAlumnos
        }
      })

      // Llamada a la función setSeries con los datos transformados
      //console.log(series, totales)
      setSeries(series)
      setTotales(totales)
    }
  }, [dataSegmentos])

  return (
    <React.Fragment>
      <Col xl="8">
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">Segmentación de Alumnos</h4>
            <Row>
              <div>
                <div id="donut-chart">
                  <ReactApexChart
                    options={options}
                    series={series}
                    type="donut"
                    height={260}
                    className="apex-charts"
                  />
                </div>
              </div>
            </Row>
            <div className="text-center text-muted">
              <Row>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-success me-1" />{" "}
                      Puntual.
                    </p>
                    <h5>{totales[1]}</h5>
                  </div>
                </Col>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-primary me-1" />{" "}
                      Ocasionalmente Atrasado
                    </p>
                    <h5>{totales[0]}</h5>
                  </div>
                </Col>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                      <i className="mdi mdi-circle text-danger me-1" /> Moroso
                      Crónico
                    </p>
                    <h5>{totales[2]}</h5>
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default PieSegmentos
